import api from '../utils/request';

class CustomInterviewAPI {
  async evaluate(evaluationData) {
    try {
      const response = await api.post('/custom-interview/evaluate', evaluationData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

const customInterviewApi = new CustomInterviewAPI();
export default customInterviewApi;